module.exports = __webpack_public_path__ + "img/3.bde89ac0.png";